import {
  GET_COURSE_TYPES
} from '../mutation-types'

const state = {
  all: []
}

const mutations = {
  [GET_COURSE_TYPES] (state, courseTypes) {
    state.all = courseTypes
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/courseTypes.js